import { Navigate, useLocation } from 'react-router-dom';

/**
 * Catch-all redirect for legacy URL prefixes from the pre-OCP-124
 * layout (when the admin SPA was mounted at /admin/* under Fastify).
 * Strips the prefix + preserves query string + hash so stale bookmarks,
 * browser autofills, and post-login redirect state (`from`) don't
 * land on a 404 NotFoundPage.
 *
 * Used as:  <Route path="/admin/*" element={<LegacyPrefixRedirect prefix="/admin" />} />
 */
export function LegacyPrefixRedirect({ prefix }: { prefix: string }) {
  const location = useLocation();
  const stripped = location.pathname.startsWith(prefix + '/')
    ? location.pathname.slice(prefix.length) || '/'
    : location.pathname === prefix
      ? '/'
      : location.pathname;
  const target = stripped + location.search + location.hash;
  return <Navigate to={target} replace />;
}
